import { Separators } from "../../Constants.ts";

interface request {
    condition: string
}

export function RoleCondition({ condition }: request) {
    if (!condition) return null;

    // Split the condition into individual parts using the primary separator ´ (180)
    const parts = condition.split('´').filter(part => part.trim() !== '');

    // Group parts into logical expressions (field, operator, value, connector)
    const expressions: any[] = [];
    let currentExpression: string[] = [];

    for (const part of parts) {
        if (part.toLowerCase() === 'and' || part.toLowerCase() === 'or' || part === '¼') {
            if (currentExpression.length > 0) {
                expressions.push({
                    field: currentExpression[0],
                    operator: currentExpression[1],
                    // Replace the 181 separator with a visual comma + space
                    value: currentExpression[2] ? currentExpression[2].split(Separators.in).join(', ') : '',
                    connector: part === '¼' ? null : part
                });
                currentExpression = [];
            }
        } else {
            currentExpression.push(part);
        }
    }

    // Add the last expression if exists
    if (currentExpression.length >= 3) {
        expressions.push({
            field: currentExpression[0],
            operator: currentExpression[1],
            // Replace the 181 separator with a visual comma + space
            value: currentExpression[2] ? currentExpression[2].split(Separators.in).join(', ') : '',
            connector: null
        });
    }

    return (
        <>
            {expressions.map((exp, idx) => (
                <div
                    key={idx}
                    className="d-flex flex-nowrap align-items-center bg-white border border-opacity-25 rounded px-2 py-1 mb-1 shadow-sm"
                    style={{ width: '100%' }}
                >
                    {/* 1. Field - Flex grow to share available space */}
                    <div
                        className="text-truncate fw-medium text-dark pe-2"
                        style={{ flex: '1 1 40%', minWidth: 0, fontSize: '0.75rem' }}
                        title={exp.field}
                    >
                        {exp.field}
                    </div>

                    {/* 2. Operator - Fixed width, no shrink/grow */}
                    <div
                        className="d-flex justify-content-center flex-shrink-0"
                        style={{ width: '65px' }}
                    >
                        <span className="badge bg-info text-white rounded-1 px-2" style={{ fontSize: '0.70rem' }}>
                            {exp.operator}
                        </span>
                    </div>

                    {/* 3. Value - Flex grow to share available space */}
                    <div
                        className="text-truncate text-muted px-2"
                        style={{ flex: '1 1 40%', minWidth: 0, fontFamily: 'monospace', fontSize: '0.75rem' }}
                        title={exp.value}
                    >
                        {exp.value}
                    </div>

                    {/* 4. Connector - Fixed width, no shrink/grow */}
                    <div
                        className="d-flex justify-content-end flex-shrink-0"
                        style={{ width: '45px' }}
                    >
                        {exp.connector ? (
                            <span className="badge bg-secondary rounded-1 px-2" style={{ fontSize: '0.70rem' }}>
                                {exp.connector.toUpperCase()}
                            </span>
                        ) : (
                            <span className="badge px-2" style={{ visibility: 'hidden', fontSize: '0.70rem' }}>
                                OR
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </>
    );
}

export default RoleCondition;